'use client';

import { useEffect, useState } from 'react';

const DESKTOP_BLOCK_SIZE = 3;
const TABLET_BLOCK_SIZE = 2;
const MOBILE_BLOCK_SIZE = 1;

const resolveBlockSize = (): number => {
  if (typeof window === 'undefined') return DESKTOP_BLOCK_SIZE;
  if (window.matchMedia('(min-width: 1240px)').matches)
    return DESKTOP_BLOCK_SIZE;
  if (window.matchMedia('(min-width: 700px)').matches) return TABLET_BLOCK_SIZE;
  return MOBILE_BLOCK_SIZE;
};

export const useResponsiveBlockSize = (): number => {
  // Resolve synchronously on the first client render (SSR falls back to
  // DESKTOP_BLOCK_SIZE inside resolveBlockSize). Starting at 3 and flipping
  // to 1/2 in an effect changed the home-feed query key one tick after
  // hydration, which dropped the SSR seed, refired page 1 with a different
  // backend interleave, and visibly reshuffled the feed on every mobile /
  // tablet visit. With the correct value on the first render the seed
  // (attached via initialData; seed-match deliberately ignores blockSize)
  // hydrates the live query key and no post-mount refetch happens.
  const [blockSize, setBlockSize] = useState(resolveBlockSize);

  useEffect(() => {
    const sync = () => setBlockSize(resolveBlockSize());
    sync();

    const mqls = [
      window.matchMedia('(min-width: 1240px)'),
      window.matchMedia('(min-width: 700px)'),
    ];
    mqls.forEach((mql) => mql.addEventListener('change', sync));
    return () => mqls.forEach((mql) => mql.removeEventListener('change', sync));
  }, []);

  return blockSize;
};
